import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { MEDIA_BREAKPOINTS } from '../../../../../mediaQueries.const';
import { AnimationDirection, AnimationDirectionType } from '../menuAnimations.util';
import { Link } from '../../../../partials/link/Link';
import { baseUnit } from '../../../../../theming/baseUnitDefinition';
import { useAnimationLogoHeightsAndWidths, AnimationLogoHeightsAndWidths } from './useAnimationLogoHeightsAndWidths';

export interface LogoDataProps {
  src: string;
  svgViewBox: string;
  alt: string;
  href: string;
}

interface LogoLogicProps {
  logoHeightInSmallScreen: number;
  logoHeightInMediumScreen: number;
  logoHeightInLargeScreen: number;
  menuAnimation?: AnimationDirectionType;
  reduceHeightAnimationDuration?: number;
}

type LogoProps = LogoDataProps & LogoLogicProps;

const getLogoStyle = (logoHeightInMediumScreen: number, logoHeightInSmallScreen: number, menuAnimation: AnimationDirectionType, reduceHeightAnimationDuration: number, largeLogoHeightsAndWidths: AnimationLogoHeightsAndWidths) => {
  return StyleSheet.create({
    base: {
      display: 'inline-flex',
      [MEDIA_BREAKPOINTS.large]: {
        height: menuAnimation === AnimationDirection.UP ? `${largeLogoHeightsAndWidths.reducedHeight}px` : `${largeLogoHeightsAndWidths.height}px`,
        width: menuAnimation === AnimationDirection.UP ? `${largeLogoHeightsAndWidths.reducedWidth}px` : `${largeLogoHeightsAndWidths.width}px`,
      },
      [MEDIA_BREAKPOINTS.medium]: {
        height: `${logoHeightInMediumScreen * baseUnit}px`,
        width: 'auto',
      },
      [MEDIA_BREAKPOINTS.small]: {
        height: `${logoHeightInSmallScreen * baseUnit}px`,
        width: 'auto',
      },
      alignItems: 'center',
      transition: `${reduceHeightAnimationDuration}ms`,
    },
    image: {
      height: '100%',
    },
  });
};

const getImageResource = (svg: string) => {
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

export const Logo: React.FunctionComponent<LogoProps> = props => {
  const { href, alt, src, logoHeightInLargeScreen, logoHeightInMediumScreen, logoHeightInSmallScreen, menuAnimation = AnimationDirection.NONE, reduceHeightAnimationDuration = 0 } = props;
  const [ref, largeLogoHeightsAndWidths] = useAnimationLogoHeightsAndWidths(logoHeightInLargeScreen);
  const style = getLogoStyle(logoHeightInMediumScreen, logoHeightInSmallScreen, menuAnimation, reduceHeightAnimationDuration, largeLogoHeightsAndWidths);
  return (
    <React.Fragment>
      <Link className={css(style.base)} href={href}>
        <img ref={ref} className={css(style.image)} alt={alt} src={getImageResource(src)} />
      </Link>
    </React.Fragment>
  );
};
